// src/graphql/mutations/featureMutations.js

export const setFeatureOverride = `mutation SetFeatureOverride($input: SetFeatureOverrideInput!) {
    setFeatureOverride(input: $input) {
        success
        error
        override {
            id
            companyId
            featureId
            enabled
            reason
            createdBy
            createdAt
        }
    }
}`;

export const removeFeatureOverride = `mutation RemoveFeatureOverride($companyId: String!, $featureId: String!) {
    removeFeatureOverride(companyId: $companyId, featureId: $featureId) {
        success
        error
    }
}`;
